<template>
    <div class="product">
        <div class="sub-title">product</div>
        <h2>{{ $t('from.product') }}</h2>
        <el-tabs v-model="activeName" @tab-click="handleClick" v-if="!isPhone">
            <el-tab-pane :label="$t('from.tab01')" name="0"></el-tab-pane>
            <el-tab-pane :label="$t('from.tab02')" name="1"></el-tab-pane>
            <el-tab-pane :label="$t('from.tab03')" name="2"></el-tab-pane>
            <el-tab-pane :label="$t('from.tab04')" name="3"></el-tab-pane>
            <el-tab-pane :label="$t('from.tab05')" name="4"></el-tab-pane>
            <el-tab-pane :label="$t('from.tab06')" name="5"></el-tab-pane>
        </el-tabs>
        <div class="isPhone" v-if="isPhone">
            <el-select v-model="activeName" @change="handleClick" placeholder="请选择">
                <el-option :label="$t('from.tab01')" value="0"></el-option>
                <el-option :label="$t('from.tab02')" value="1"></el-option>
                <el-option :label="$t('from.tab03')" value="2"></el-option>
                <el-option :label="$t('from.tab04')" value="3"></el-option>
                <el-option :label="$t('from.tab05')" value="4"></el-option>
                <el-option :label="$t('from.tab06')" value="5"></el-option>
            </el-select>
        </div>
        <div class="product-box" v-if="activeName == 0">
            <div class="box">
                <div class="img-box" @click="handlePage(1)">
                    <div class="isShow"><img src="../assets/images/product/forward.png" alt=""></div>
                    <img src="../assets/images/product/img01.jpg" alt="" style="transform: scale(1.8);">
                </div>
                <div class="product-title">{{ $t('from.product01') }}</div>
            </div>
            <div class="box">
                <div class="img-box" @click="handlePage(2)">
                    <div class="isShow"><img src="../assets/images/product/forward.png" alt=""></div>
                    <img src="../assets/images/product/img02.jpg" alt="" style="transform: scale(1.2);">
                </div>
                <div class="product-title">{{ $t('from.product02') }}</div>
            </div>
            <div class="box">
                <div class="img-box" @click="handlePage(3)">
                    <div class="isShow"><img src="../assets/images/product/forward.png" alt=""></div>
                    <img src="../assets/images/product/img03.png" alt="" style="transform: scale(2);">
                </div>
                <div class="product-title">{{ $t('from.product03') }}</div>
            </div>
            <div class="box">
                <div class="img-box" @click="handlePage(4)">
                    <div class="isShow"><img src="../assets/images/product/forward.png" alt=""></div>
                    <img src="../assets/images/product/img04.jpg" alt="">
                </div>
                <div class="product-title">{{ $t('from.product04') }}</div>
            </div>
        </div>
        <div class="product-box" v-if="activeName == 1">
            <div class="box">
                <div class="img-box" @click="handlePage(5)">
                    <div class="isShow"><img src="../assets/images/product/forward.png" alt=""></div>
                    <img src="../assets/images/product/img05.jpg" alt="" style="transform: scale(1.2);">
                </div>
                <div class="product-title">{{ $t('from.product05') }}</div>
            </div>
            <div class="box">
                <div class="img-box" @click="handlePage(6)">
                    <div class="isShow"><img src="../assets/images/product/forward.png" alt=""></div>
                    <img src="../assets/images/product/img06.jpg" alt="" style="transform: scale(1.4);">
                </div>
                <div class="product-title">{{ $t('from.product06') }}</div>
            </div>
            <div class="box">
                <div class="img-box" @click="handlePage(7)">
                    <div class="isShow"><img src="../assets/images/product/forward.png" alt=""></div>
                    <img src="../assets/images/product/img07.jpg" alt="" style="transform: scale(1.2);">
                </div>
                <div class="product-title">{{ $t('from.product07') }}</div>
            </div>
            <div class="box">
                <div class="img-box" @click="handlePage(8)">
                    <div class="isShow"><img src="../assets/images/product/forward.png" alt=""></div>
                    <img src="../assets/images/product/img08.jpg" alt="">
                </div>
                <div class="product-title">{{ $t('from.product08') }}</div>
            </div>
        </div>
        <div class="product-box" v-if="activeName == 2">
            <div class="box">
                <div class="img-box" @click="handlePage(9)">
                    <div class="isShow"><img src="../assets/images/product/forward.png" alt=""></div>
                    <img src="../assets/images/product/img09.jpg" alt="">
                </div>
                <div class="product-title">{{ $t('from.product09') }}</div>
            </div>
            <div class="box">
                <div class="img-box" @click="handlePage(10)">
                    <div class="isShow"><img src="../assets/images/product/forward.png" alt=""></div>
                    <img src="../assets/images/product/img10.jpg" alt="">
                </div>
                <div class="product-title">{{ $t('from.product10') }}</div>
            </div>
            <div class="box">
                <div class="img-box" @click="handlePage(11)">
                    <div class="isShow"><img src="../assets/images/product/forward.png" alt=""></div>
                    <img src="../assets/images/product/img11.jpg" alt="">
                </div>
                <div class="product-title">{{ $t('from.product11') }}</div>
            </div>
        </div>
        <div class="product-box" v-if="activeName == 3">
            <div class="box">
                <div class="img-box" @click="handlePage(12)">
                    <div class="isShow"><img src="../assets/images/product/forward.png" alt=""></div>
                    <img src="../assets/images/product/img12.png" alt="" style="transform: scale(1.6);">
                </div>
                <div class="product-title">{{ $t('from.product12') }}</div>
            </div>
            <div class="box">
                <div class="img-box" @click="handlePage(13)">
                    <div class="isShow"><img src="../assets/images/product/forward.png" alt=""></div>
                    <img src="../assets/images/product/img13.jpg" alt="" style="transform: scale(1.8);">
                </div>
                <div class="product-title">{{ $t('from.product13') }}</div>
            </div>
            <div class="box">
                <div class="img-box" @click="handlePage(14)">
                    <div class="isShow"><img src="../assets/images/product/forward.png" alt=""></div>
                    <img src="../assets/images/product/img14.png" alt="" style="transform: scale(1.8);">
                </div>
                <div class="product-title">{{ $t('from.product14') }}</div>
            </div>
            <div class="box">
                <div class="img-box" @click="handlePage(15)">
                    <div class="isShow"><img src="../assets/images/product/forward.png" alt=""></div>
                    <img src="../assets/images/product/img15.png" alt="" style="transform: scale(1.8);">
                </div>
                <div class="product-title">{{ $t('from.product15') }}</div>
            </div>
        </div>
        <div class="product-box" v-if="activeName == 4">
            <div class="box">
                <div class="img-box" @click="handlePage(16)">
                    <div class="isShow"><img src="../assets/images/product/forward.png" alt=""></div>
                    <img src="../assets/images/product/img16.jpg" alt="" style="transform: scale(1.2);">
                </div>
                <div class="product-title">{{ $t('from.product16') }}</div>
            </div>
            <div class="box">
                <div class="img-box" @click="handlePage(17)">
                    <div class="isShow"><img src="../assets/images/product/forward.png" alt=""></div>
                    <img src="../assets/images/product/img17.png" alt="" style="transform: scale(1.2);">
                </div>
                <div class="product-title">{{ $t('from.product17') }}</div>
            </div>
            <div class="box">
                <div class="img-box" @click="handlePage(18)">
                    <div class="isShow"><img src="../assets/images/product/forward.png" alt=""></div>
                    <img src="../assets/images/product/img18.png" alt="" style="transform: scale(1.2);">
                </div>
                <div class="product-title">{{ $t('from.product18') }}</div>
            </div>
        </div>
        <div class="product-box" v-if="activeName == 5">
            <div class="box">
                <div class="img-box" @click="handlePage(19)">
                    <div class="isShow"><img src="../assets/images/product/forward.png" alt=""></div>
                    <img src="../assets/images/product/img19.png" alt="" style="transform: scale(1.2);">
                </div>
                <div class="product-title">{{ $t('from.product19') }}</div>
            </div>
            <div class="box">
                <div class="img-box" @click="handlePage(20)">
                    <div class="isShow"><img src="../assets/images/product/forward.png" alt=""></div>
                    <img src="../assets/images/product/img20.png" alt="" style="transform: scale(1.2);">
                </div>
                <div class="product-title">{{ $t('from.product20') }}</div>
            </div>
            <div class="box">
                <div class="img-box" @click="handlePage(21)">
                    <div class="isShow"><img src="../assets/images/product/forward.png" alt=""></div>
                    <img src="../assets/images/product/img21.png" alt="" style="transform: scale(1.2);">
                </div>
                <div class="product-title">{{ $t('from.product21') }}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default ({
    data() {
        return {
            activeName: 0,
            isPhone: false
        }
    },
    mounted() {
        var info = navigator.userAgent;
        //通过正则表达式的test方法判断是否包含“Mobile”字符串
        this.isPhone = /mobile/i.test(info);
        //如果包含“Mobile”（是手机设备）则返回true
        console.log('isPhone', this.isPhone)
    },
    methods: {
        handleGoTop() {
            scrollTo(0, 0);
        },
        handleClick(tab, event) {
            console.log(tab, event);
            if (this.isPhone) {
                this.activeName = tab
            } else {
                this.activeName = tab.name
            }
        },
        handlePage(index) {
            this.$router.push({
                name: 'product',
                query: {
                    index: index
                }
            })
        },
    }
})
</script>
<style lang="scss" scoped>
@media only screen and (max-width: 750px) {
    .isPhone {
        display: flex;
    }

    /deep/.el-tabs__item {
        font-size: 12px;
    }

    /deep/.el-tabs__nav {
        float: none;
        display: flex;
        justify-content: center;
    }

    /deep/.el-tabs__active-bar {
        height: 0;
    }

    /* 定义动画 */
    @keyframes slideInLeft {
        from {
            transform: scaleX(0);
            /* 初始状态为水平缩放为0 */
            transition: transform 1s ease-out;
            /* 过渡效果 */
        }

        to {
            transform: scaleX(1);
        }
    }

    .product {
        background-color: #fff;
        padding: 15px;
        box-sizing: border-box;

        .product-box {
            display: flex;
            flex-wrap: wrap;
            margin-top: 20px;


            .box:hover {
                .img-box {
                    box-shadow: 0 0 5px #c5c5c5;

                    .isShow {
                        display: block;
                    }

                }

                .product-title {
                    color: #1b5fc1;

                }
            }

            .box {
                width: 48%;
                display: flex;
                align-items: center;
                flex-direction: column;
                margin-right: 1%;

                .img-box {
                    height: 150px;
                    border: 1px solid #a3a3a3;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: relative;
                    animation-name: slideInLeft;
                    animation-duration: 0.5s;
                    overflow: hidden;

                    .isShow {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        z-index: 99;
                        display: none;
                        background-color: #1b5fc1;
                        width: 70px;
                        height: 70px;
                        border-radius: 40px;
                        padding: 20px;
                        box-sizing: border-box;

                        img {
                            width: 30px;
                            height: 30px;
                            transform: scale(-1, 1);
                        }
                    }

                    img {
                        width: 100%;

                    }
                }

                .product-title {
                    font-size: 14px;
                    color: #333;
                    line-height: 28px;
                    margin-top: 20px;
                    text-align: center;
                    max-width: 400px;
                    word-break: break-all;
                    word-wrap: break-word;
                }


            }
        }

    }
}

@media only screen and (min-width: 751px) {

    /deep/.el-tabs__item {
        font-size: 24px;
    }

    /deep/.el-tabs__nav {
        float: none;
        display: flex;
        justify-content: center;
    }

    /deep/.el-tabs__active-bar {
        height: 0;
    }

    /* 定义动画 */
    @keyframes slideInLeft {
        from {
            transform: scaleX(0);
            /* 初始状态为水平缩放为0 */
            transition: transform 1s ease-out;
            /* 过渡效果 */
        }

        to {
            transform: scaleX(1);
        }
    }

    .product {
        background-color: #fff;
        padding: 120px;
        box-sizing: border-box;

        .product-box {
            display: flex;
            margin-top: 40px;


            .box:hover {
                .img-box {
                    box-shadow: 0 0 10px #c5c5c5;

                    .isShow {
                        display: block;
                    }

                }

                .product-title {
                    color: #1b5fc1;

                }
            }

            .box {
                width: 24%;
                display: flex;
                align-items: center;
                flex-direction: column;
                margin-right: 1%;

                .img-box {
                    height: 300px;
                    border: 1px solid #a3a3a3;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: relative;
                    animation-name: slideInLeft;
                    animation-duration: 0.5s;
                    overflow: hidden;

                    .isShow {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        z-index: 99;
                        display: none;
                        background-color: #1b5fc1;
                        width: 150px;
                        height: 150px;
                        border-radius: 80px;
                        padding: 45px;
                        box-sizing: border-box;

                        img {
                            width: 60px;
                            height: 60px;
                            transform: scale(-1, 1);
                        }
                    }

                    img {
                        width: 100%;

                    }
                }

                .product-title {
                    font-size: 14px;
                    color: #333;
                    line-height: 28px;
                    margin-top: 20px;
                    text-align: center;
                    max-width: 400px;
                    word-break: break-all;
                    word-wrap: break-word;
                }


            }
        }

    }
}
</style>